import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/components/buttons/button.css';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import LoadingSpinner from '../common/LoadingSpinner';

function CTAButton({
	onButtonClick,
	buttonLabel = 'Continue',
	isDisabled = false,
	clickSound = null,
	buttonId = 'n/a',
	extraClassName = '',
}) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);

	const bigbeatEvent = onelpsParams.bigbeat ? styles[onelpsParams.bigbeat] : '';
	const buttonClassNames = `${styles.button} ${styles[onelpsParams.gameId]} ${styles[onelpsParams.pageType]} ${styles[extraClassName]} ${bigbeatEvent}`;

	return (
		<>
			<button
				type={'button'}
				onClick={(e) => {
					if(clickSound){
						new Audio(clickSound).play();
					}
					onButtonClick(e);
				}}
				className={buttonClassNames}
				disabled={isDisabled}
				id={buttonId}
				data-bigbeat={onelpsParams.bigbeat}
			>
				{(onelpsParams.abTestFeatureFlags?.['CONV-12361-CreateOneClickLPForHoH'] )
					? <>
						<span className={styles.bar}></span>
						<span className={styles.buttonLabel}>{buttonLabel}</span>
						<span className={styles.icon}></span></>
					: buttonLabel}
			</button>
			{isDisabled && (
				<LoadingSpinner
					isOnCtaButton
					isBigbeat={!!onelpsParams.bigbeat}
					extraClassName={extraClassName}
				/>
			)}
		</>
	);
}

export default CTAButton;

CTAButton.propTypes = {
	onButtonClick: PropTypes.func.isRequired,
	buttonLabel: PropTypes.string,
	isDisabled: PropTypes.bool,
	clickSound: PropTypes.string,
	buttonId: PropTypes.string,
	extraClassName: PropTypes.string,
};
